import React from "react";
import RatesDashboardRoomTypeCell from "./RatesDashboardRoomTypeCell";
import RatesDashboardRateCell from "./RatesDashboardRateCell";
import DateHelper from "../DateHelper/DateHelper";

class RatesDashboardDateGrid extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var room_types_and_rates = [];
    var room_types_count = 0;
    var rates_count = 0;
    var idx = 0;

    for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++) {
      
      var room_type = this.props.room_types[i];
 
      // console.log("room_type", room_type.type_of_booking)
      idx = 0;
      for (
        var d = new Date(this.props.start_date);
        d <= new Date(this.props.end_date);
        d.setDate(d.getDate() + 1)
      ) {
        var date_data =
          this.props.dailyRoomTypes[
            DateHelper.printDateToScreen(d, "yyyy-MM-dd")
          ];
        // console.log("date grid date_data", date_data);
        
        if (date_data) {
          room_types_and_rates.push(
            <RatesDashboardRoomTypeCell
              key={"room_type_" + room_type.id + "_" + d}
              room_type={room_type}
              heatMapColors={this.props.heatMapColors}
              top={this.calculateTop(room_types_count, rates_count)}
              left={this.calculateLeft(idx)}
              toggleSetting={this.props.toggleSetting}
              room_type_date_analytics_path={this.props.room_type_date_analytics_path
                .replace(":room_type", room_type.id)
                .replace(
                  ":date",
                  DateHelper.printDateToScreen(d, "yyyy-MM-dd")
                )}
              room_type_rate_date_analytics_path={this.props.room_type_rate_date_analytics_path
                .replace(":room_type", room_type.id)
                .replace(
                  ":date",
                  DateHelper.printDateToScreen(d, "yyyy-MM-dd")
                )}
              edit_room_type_price_path={this.props.edit_room_type_price_path.replace(
                ":room_type",
                room_type.id
              )}
              date_data={date_data}
            />
          );
        } else {
          room_types_and_rates.push(
            <RatesDashboardRoomTypeCell
              key={"room_type_" + room_type.id + "_" + d}
              room_type={room_type}
              top={this.calculateTop(room_types_count, rates_count)}
              left={this.calculateLeft(idx)}
            />
          );
        }
        idx++;
      }

      room_types_count++;

      if (typeof room_type.collapsed === "undefined" || room_type.collapsed) {
        // do not add the rates
      } else {
        for (var j = 0, jlen = room_type.rates.length; j < jlen; j++) {
          var rate = room_type.rates[j];
          idx = 0;
          for (
            var d = new Date(this.props.start_date);
            d <= new Date(this.props.end_date);
            d.setDate(d.getDate() + 1)
          ) {
            var date_data = this.props.roomTypeRates && this.props.roomTypeRates[room_type.id] ? 
              this.props.roomTypeRates[room_type.id][
                DateHelper.printDateToScreen(d, "yyyy-MM-dd")
              ] : [];

            room_types_and_rates.push(
              <RatesDashboardRateCell
                key={"room_type_" + room_type.id + "_rate_" + rate.id + "_" + d}
                heatMapColors={this.props.heatMapColors}
                room_type={room_type}
                rate={rate}
                room_type_rate_date_analytics_path={this.props.room_type_rate_date_analytics_path
                  .replace(":room_type", room_type.id)
                  .replace(":rate", rate.id)
                  .replace(
                    ":date",
                    DateHelper.printDateToScreen(d, "yyyy-MM-dd")
                  )}
                date_data={date_data}
                toggleSetting={this.props.toggleSetting}
                top={this.calculateTop(room_types_count, rates_count)}
                left={this.calculateLeft(idx)}
              />
            );
            idx++;
          }

          rates_count++;
        }
      }
    }

    return <div className="RatesDashboardDateGrid">{room_types_and_rates}</div>;
  }

  calculateTop(room_types_count, rates_count) {
    return room_types_count * 80 + rates_count * 60;
  }

  calculateLeft(idx) {
    return idx * (this.props.dateView == "month" ? 70 : 160);
  }
}

export default RatesDashboardDateGrid;
